import React, { Component } from 'react';
import dateTimeHelper from '../../Helpers/datetimeHelper';
import timesheet from "./timesheet.module.css";

class TimeFrame extends Component 
{
    render ()
    {
        const className = timesheet.strippedrow
            + (!this.props.showBeforeWorkingHours && this.props.calendarTimeframe.StartTime < dateTimeHelper.convertTimeToMinutes(this.props.dailyWorkStartTime)
                ? ` ${timesheet.hidden} `
                : " ")
            + (!this.props.showAfterWorkingHours && this.props.calendarTimeframe.StartTime > dateTimeHelper.convertTimeToMinutes(this.props.dailyWorkEndTime) - this.props.intervalToShowInMinutes
                ? ` ${timesheet.hidden} `
                : " ")
            + (this.props.calendarTimeframe.IsSelected
                ? timesheet.selectedTimeFrame
                : timesheet.timeframe)
            + (this.props.calendarTimeframe.StartTime < dateTimeHelper.convertTimeToMinutes(this.props.dailyWorkStartTime)
                ? ` ${timesheet.timeframeOut}`
                : "")
            + (this.props.calendarTimeframe.StartTime > dateTimeHelper.convertTimeToMinutes(this.props.dailyWorkEndTime) - this.props.intervalToShowInMinutes
                ? ` ${timesheet.timeframeOut}`
                : "");

        return (
            <div
                key={this.props.calendarTimeframe.StartTime}
                id={this.props.calendarTimeframe.DivId}
                className={className}
                onClick={(e) => this.props.onClick(e)}
            >
                {dateTimeHelper.convertMinutesToTime(this.props.calendarTimeframe.StartTime)}
            </div>
        );
    }
}


export default TimeFrame;
